import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";

const documentSubTabs = [
  { label: "All", to: "/documents" },
  { label: "Completed", to: "/documents/completed" },
  { label: "Awaiting Signature", to: "/documents/awaiting" },
  { label: "Voided", to: "/documents/voided" },
  { label: "Draft", to: "/documents/draft" },
  { label: "Received", to: "/documents/received" },
  { label: "Trash", to: "/documents/trash" },
];

const templatesSubTabs = [
  { label: "Manage Template", to: "/templates" },
  { label: "Create Template", to: "/templates/new" },
];

const signSubTabs = [
  { label: "Sign", to: "/" },
  // { label: "Overview", to: "/sign/overview" },
];

export default function TopNavigation() {
  const { pathname } = useLocation();

  const [showDocumentsTabs, setShowDocumentsTabs] = useState(false);
  const [showTemplatesTabs, setShowTemplatesTabs] = useState(false);
  const [showSignTabs, setShowSignTabs] = useState(false);

  useEffect(() => {
    setShowDocumentsTabs(pathname.startsWith("/documents"));
    setShowTemplatesTabs(pathname.startsWith("/templates"));
    setShowSignTabs(
      pathname === "/" ||
        // pathname.startsWith("/overview") ||
        pathname.startsWith("/otherSigner") ||
        pathname.startsWith("/sign")
    );
  }, [pathname]);

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      {showDocumentsTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {documentSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}

      {showTemplatesTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {templatesSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}
      {showSignTabs && (
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
          }}
        >
          <Tabs
            value={pathname}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              "& .MuiTab-root": {
                minWidth: "unset",
                px: { xs: 1, sm: 2 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              },
            }}
          >
            {signSubTabs.map((sub) => (
              <Tab
                key={sub.to}
                label={sub.label}
                value={sub.to}
                component={NavLink}
                to={sub.to}
                disableRipple
              />
            ))}
          </Tabs>
        </Box>
      )}
    </Box>
  );
}
